import RmCallBack from './rm-callback';

import { createContainer } from '@dbk-legacy/muster/react';

export default createContainer({
  $queries: {
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
          width: true,
          height: true,
        },
      },
    },
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    screen: {
      width: true,
      height: true,
      isSmall: true,
    },
    sendRMCallBack: {
      $call: 'callback.getResponse',
    },
    callback: {
      displayMsg: true,
      success: true,
      screen: true,
      pagename: true,
      setScreen: { $call: 'setScreen' },
    },
    ui: {
      history: {
        canGoBack: true,
        goBack: { $call: 'goBack' },
        currentLocation: {
          pathname: true,
        },
      },
    },
    edelivery: {
      showPrompt: true,
      updateUserPreference: { $call: 'updateUserPreference' },
      saveUserPreferences: { $call: 'saveUserPreferences' },
    },
  },
})(RmCallBack);
